import { __assign } from 'tslib';
import { Position } from '@keepeek/commons';

function getTagsDataByPosition(tagsConfiguration, elementLabels, maxTagsToDisplay) {
    // Filter tags that we want to display
    var tagsToDisplay = elementLabels === null || elementLabels === void 0 ? void 0 : elementLabels.filter(function (label) { var _a; return label.id && ((_a = tagsConfiguration === null || tagsConfiguration === void 0 ? void 0 : tagsConfiguration.tagsToDisplayId) === null || _a === void 0 ? void 0 : _a.includes(label.id)); });
    // Filter tags that we don't want to display
    var hiddenTags = maxTagsToDisplay
        ? tagsToDisplay === null || tagsToDisplay === void 0 ? void 0 : tagsToDisplay.slice(-((tagsToDisplay === null || tagsToDisplay === void 0 ? void 0 : tagsToDisplay.length) - maxTagsToDisplay + 1))
        : tagsToDisplay;
    var tagsData = tagsConfiguration
        ? tagsToDisplay === null || tagsToDisplay === void 0 ? void 0 : tagsToDisplay.filter(function (_label, i) { return !maxTagsToDisplay || (maxTagsToDisplay && i < maxTagsToDisplay); }).map(function (label, index) {
            var _a, _b;
            // If the max tag number is reached, we display a tag with the number of hidden tags and the detail is on hover
            // Example : "+ 2" and on hover "Document informatif / Status Ok"
            return __assign(__assign({}, (maxTagsToDisplay && index === maxTagsToDisplay - 1 && (hiddenTags === null || hiddenTags === void 0 ? void 0 : hiddenTags.length) !== 1
                ? {
                    title: "+ ".concat(hiddenTags === null || hiddenTags === void 0 ? void 0 : hiddenTags.length),
                    displayOtherTagsCount: true,
                    titleOnHover: hiddenTags === null || hiddenTags === void 0 ? void 0 : hiddenTags.map(function (label) { return label.name; }).join("\n")
                }
                : {
                    title: (_a = label.name) !== null && _a !== void 0 ? _a : ""
                })), { backgroundColor: label.backgroundColor, textColor: label.textColor, position: (_b = tagsConfiguration.position) !== null && _b !== void 0 ? _b : Position.TopRight, borderRadius: tagsConfiguration.borderRadius, fontSize: tagsConfiguration.fontSize, marginBottom: tagsConfiguration.marginBottom, marginLeft: tagsConfiguration.marginLeft, marginRight: tagsConfiguration.marginRight, marginTop: tagsConfiguration.marginTop, padding: tagsConfiguration.padding });
        })
        : undefined;
    var tagsDataByPosition = new Map();
    if (tagsData) {
        var _loop_1 = function (positionAsString) {
            var position = Position[positionAsString];
            var tagsDataForCurrentPosition = tagsData === null || tagsData === void 0 ? void 0 : tagsData.filter(function (tagData) { return tagData.position === position; });
            if (tagsDataForCurrentPosition === null || tagsDataForCurrentPosition === void 0 ? void 0 : tagsDataForCurrentPosition.length) {
                tagsDataByPosition.set(position, tagsDataForCurrentPosition);
            }
        };
        for (var positionAsString in Position) {
            _loop_1(positionAsString);
        }
    }
    return tagsDataByPosition || undefined;
}

export { getTagsDataByPosition };
//# sourceMappingURL=getTagsDataByPosition.js.map
